import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import StartView from '../views/StartView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'raetsel_ueberblick',
    component: () => import('../views/RaetselUeberblickView.vue')
  },
  {
    path: '/start',
    name: 'start',
    component: StartView
  },
  {
    path: '/raetsel/:id',
    name: 'raetsel',
    component: () => import('../views/RaetselView.vue')
  },
  {
    path: '/raetsel_manager',
    name: 'raetsel_manager',
    component: () => import('../views/RaetselManagerView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
